import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1290px;
  width: calc(100% - 128px);
  margin: 0 auto;

  @media (min-width: 1366px) {
    width: 1290px;
  }
`;

export const ColumnWrapper = styled.div`
  flex-basis: 20%;
  margin-bottom: 36px;
  snippets.cson &:last-child {
    flex-basis: 19%;
  }
`;

export const Columns = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Link = styled.a`
  display: block;
  margin-bottom: 13px;
  height: 19px;
  min-width: 236px;
`;

export const CopyrightAndLegals = styled.div`
  padding-top: 24px;
  display: flex;
  align-items: center;
  width: calc(100% - 128px);
  margin: 0 auto;

  @media (min-width: 1366px) {
    width: 1290px;
  }
`;

export const LegalsSide = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const LegalLink = styled.a`
  margin: 0 8px;
  display: flex;
  align-items: center;
`;

export const HelpLink = styled.a`
  display: flex;
  align-items: center;
  margin-right: 24px;
  & svg {
    margin-right: 8px;
  }
`;

export const HelpSide = styled.div`
  display: flex;
  align-items: center;
`;

export const PaymentsSide = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const HelpAndPayments = styled(Container)`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const PaymentMethods = styled.div`
  display: none;
  @media (min-width: 1096px) {
    display: flex;
    align-items: center;
    margin-right: 24px;
    & > img {
      margin-right: 16px;
    }
    & > svg {
      margin-right: 16px;
    }
  }
`;

export const Line = styled.div`
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
`;
